module.exports = __webpack_public_path__ + "img/neuro-logo.53c2031b.svg";